import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

/**
 * Encrypts a plain string using AES-CBC with the app secret key,
 * matching the original portal's Encryption() implementation
 * (js/main.js / js/index.js) so the backend keeps accepting the token.
 */
export function encryptText(plainText) {
  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  const iv = CryptoJS.enc.Utf8.parse(SECRET_KEY);

  return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key, {
    keySize: 16,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
}

/**
 * Builds the encrypted credential token the backend expects:
 * AES( "<username>`<password>" )
 */
export function buildCredentialToken(username, password) {
  return encryptText(`${username}\`${password}`);
}
